export default __webpack_public_path__ + "alert-circle.svg";